<template>
<div style="width: 100%">
	<v-tooltip top slot="activator">
		<v-btn
			slot="activator"
			color="indigo lighten-3"
			dark
			fab
			@click="addPay"
			v-if="editable"
		>
			<v-icon>add</v-icon>
		</v-btn>
		<span>{{$t('personal_finance.add_input_button')}}</span>
	</v-tooltip>
	<v-card style="width: 100%">
		<v-data-table
			:headers="headers"
			:items="inputFinances"
			hide-actions
		>
			<template slot="items" slot-scope="props">
				<td>{{ props.item.id }}</td>
				<td>{{ props.item.amount }}</td>
				<td>{{ props.item.comment }}</td>
				<td>{{ props.item.created_at }}</td>
				<td v-if="!hasRole('manager')">
					{{ props.item.transaction ? props.item.transaction.sender_user.name: null }}
				</td>
				<td class="text-xs-center" v-if="editable && props.item.editable">
					<div class="button-group" >
						<v-btn fab dark small
							color="indigo lighten-2"
							@click="editPay(props.item)"
						>
							<v-icon dark>edit</v-icon>
						</v-btn>
						<ConfirmDialog class="delete-confirm"
							v-bind="propConfirmDialog"
							@accept="onDeletePay(props.item.id)"
							:tooltip="$t('common.delete')"
						>
							<v-icon dark>delete</v-icon>
						</ConfirmDialog>
					</div>
				</td>
			</template>
		</v-data-table>
	</v-card>
	<finance-dialog
		v-model="dialog"
		:editablePay="editablePay"
		v-if="editable"
	/>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { HEADERS_TABLE_PERSONAL_FINANCE } from '../../constants'
import { localeHeadersPersonalFinances } from "../../utils/helpers";
import FinanceDialog from './FinanceDialog'
import ConfirmDialog from '../../components/ConfirmDialog'
import { notify } from '../../utils/notifications'

export default {
	components: {
		FinanceDialog,
		ConfirmDialog
	},
	props: {
		editable: {
			type: Boolean,
			default: true
		}
	},
	data: (vm) => ({
		dialog: false,
		editablePay: null,
		propConfirmDialog: {
			message: vm.$t('personal_finance.confirm_message_pay'),
			title: vm.$t('common.confirm'),
			btnProps: {
				fab: true,
				dark: true,
				small: true,
				color: 'red lighten-2'
			}
		}
	}),
	computed: {
		...mapGetters({
			inputFinances: 'finance/getInputFinance',
			hasRole: 'auth/hasRole'
		}),
		headers() {
			let headers = localeHeadersPersonalFinances(HEADERS_TABLE_PERSONAL_FINANCE, this.$t)
			if(!this.editable) {
				headers = localeHeadersPersonalFinances(HEADERS_TABLE_PERSONAL_FINANCE, this.$t)
					.filter((item,index) => {
						return item.value != 'actions'
					})
			}
			if(this.hasRole('manager')) {
				headers = localeHeadersPersonalFinances(HEADERS_TABLE_PERSONAL_FINANCE, this.$t)
					.filter((item,index) => {
						return item.value != 'transfer_user_name'
					})
			}

			headers = headers.filter((item,index) => {
				return item.value != 'category'
			})
			return headers;
		}
	},
	methods: {
		...mapActions({
			deletePay: 'finance/deletePay'
		}),
		addPay() {
			this.dialog = true
			this.editablePay = null
		},
		editPay(pay) {
			this.dialog = true
			this.editablePay = pay
		},
		onDeletePay(id) {
			this.deletePay(id)
				.then(() => {
					this.$notify({
						...notify,
						text: this.$t('notifications.deleted', { type: this.$t('personal_finance.finance') }),
					})
				})
		}
	}
}
</script>

<style>
.button-group {
	display: inline-block;
}
</style>
